export default __webpack_public_path__ + "static/freight-forwarding-automation-5ac1328751c408ea5a2418e4d5c1acbb.png";